import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { isModalActive } from 'Store/reducers';
import * as uiActions from 'Store/ui/actions';

import Lightbox from 'Components/Lightbox';
import SectionHeader from 'Components/SectionHeader';
import TextBlock from 'Components/TextBlock';
import ContactLink from 'Components/ContactLink';
import Button from 'Components/Button';

class ReadOnlyModal extends React.PureComponent {
  render() {
    const { showReadOnlyModal, hideModal } = this.props;
    const link = (
      <ContactLink
        type="text"
        label="contact us"
        clickSideEffect={() => hideModal('read-only-mode')}
      />
    );
    return (
      <Lightbox
        visible={showReadOnlyModal}
        closeHandler={() => hideModal('read-only-mode')}
        type="read-only"
      >
        <SectionHeader title="Site Maintenance" />
        <TextBlock
          description={[
            <p className="TextBlock__paragraph">
              We’re working on a fix and the site should be back up shortly.
            </p>,
            <p className="TextBlock__paragraph">
              Refresh the page in a moment and{' '}
              <a
                href="mailto:support.schools@tinybop.com"
                className="u-text-link"
              >
                contact us
              </a>{' '}
              if the issue persists.
            </p>,
          ]}
        />
        <Button
          clickHandler={() => window.location.reload()}
          label="Refresh"
          buttonType="primary-mono"
        />
      </Lightbox>
    );
  }
}

const mapStateToProps = state => {
  return {
    showReadOnlyModal: isModalActive(state, 'read-only-mode'),
  };
};

ReadOnlyModal.propTypes = {
  showReadOnlyModal: PropTypes.bool.isRequired,
  hideModal: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, { hideModal: uiActions.hideModal })(
  ReadOnlyModal
);
